import HttpFactory from "~/repository/http.factory";
import type { PaginatedResponse } from "~/types/shared/response/paginated.response";
import type { PaginationRequest } from "~/types/shared/request/pagination.request";
import type { ReportAggregateResponse } from "~/types/report/response/report.aggregate.response";

export default class ReportClient extends HttpFactory {
  private ADMIN_RESOURCE = "/admin/report";
  private CHOICES_RESOURCE = "/choices/report";
  private headers: HeadersInit = {
    "Content-type": "application/json",
  };

  async findAll(
    request?: PaginationRequest
  ): Promise<PaginatedResponse<ReportAggregateResponse>> {
    return await this.call<PaginatedResponse<ReportAggregateResponse>>(
      "POST",
      `${this.ADMIN_RESOURCE}/list`,
      this.getAuthenticationHeaders(),
      request
    );
  }

  async downloadReport(scodiCampaignUuid: string): Promise<Blob> {
    return await this.call<Blob>(
      this.HTTP_GET,
      `${this.ADMIN_RESOURCE}/download/xlsx/${scodiCampaignUuid}`,
      this.getAuthenticationHeaders()
    );
  }
}
